import { Helmet } from "react-helmet";
import BreadCumbInformationAndNews from "../../components/informationAndNews/BreadCrumbInformationAndNews";
import Content from "../../components/informationAndNews/Content";
import Footer from "../../components/shared/Footer";
import Navbar from "../../components/shared/Navbar";
import RightBar from "../../components/shared/RightBar";

export default function InformationAndNews() {
    return (
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <title>Informasi dan berita - BPR Palu Anugerah</title>
                <meta name="description" content="Dapatkan informasi terbaru dan berita seputar BPR Palu Anugerah. Tetap update dengan perkembangan terkini dari kami." />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Informasi dan berita - BPR Palu Anugerah" />
                <meta property="og:description" content="Dapatkan informasi terbaru dan berita seputar BPR Palu Anugerah. Tetap update dengan perkembangan terkini dari kami." />
                <meta property="og:type" content="website" />
            </Helmet>
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <BreadCumbInformationAndNews></BreadCumbInformationAndNews>
                <Content></Content>
            </main>
            <Footer />
        </div>
    )
}